<template>
  <div class="scheme-content">
    <div class="banner">
      <div class="title">应用案例</div>
      <div class="info"> 智能检测系统护航隧道、桥梁、道路、矿山等复杂场景的基建全生命周期安全管控。</div>
    </div>
    <div class="scheme-list">
      <div class="case-top" >
        <div class="case-item" @click="caseActive = index" v-for="(item,index) in caseList" :class="{'active': caseActive === index}" :key="index">{{item.title}}</div>
      </div>
      <el-row :gutter="22">
        <el-col :sm="12" :xs="24" :md="8"  v-for="child in caseList[caseActive].children" :key="child.title">
          <div class="item" >
            <div class="title">{{ child.title }}</div>
            <div class="info" :title="child.content">{{ child.content }}</div>
<!--            <div class="link" >了解更多 <i class="el-icon-arrow-right"></i></div>-->
            <img :src="child.img" alt="">

          </div>
        </el-col>
      </el-row>
    </div>
    <footerView></footerView>
  </div>
</template>

<script>
import footerView from "@/components/footerView.vue";
export default {
  name: "CaseView",
  components:{
    footerView
  },
  data(){
    return {
      caseList:[
        {
          title: '隧道工程检测监测方案',
          children: [
            {
              title:'青岛地铁8号线',
              content:'青岛地铁8号线大洋站-青岛北站进行的巡检设备热成像检测现场应用，利用热成像技术对青岛地铁运营区段内隧道温度进行检测，防止出现高温区域，产生安全隐患。检测结果表示，巡检设备能对隧道整体温度进行有效监测。',
              img: '/static/case-1-1.png'
            },
            {
              title:'青岛地铁3号线',
              content:'青岛地铁3号线青岛北站进行的巡检装备远程操作及定位功能现场应用，测试巡检装备实时数据传输功能与定位功能。后续可通过站台处网页对巡检装备进行控制，完成一系列检测功能。经测试，定位效果良好，结合多方法实现了巡检装备厘米级别定位，能够实时获取巡检装备位置，保证巡检装备在检测出病害后标记相应的病害位置。',
              img: '/static/case-1-2.png'
            },
            {
              title:'青岛地铁1号线',
              content:'案例为在青岛地铁1号线 红岛科技馆站- 大洋站区间进行的巡检设备接触轨检测模块现场应用，帮助青岛地铁对接触轨表面病害进行检测，同时对接触轨几何参数进行检测。检测结果显示，巡检设备能够有效识别接触轨表面病害，对病害进行识别和分类，并记录相应的病害位置;几何参数测量精度可以达到0.01mm，远大于运营公司要求的检测精度。',
              img: '/static/case-1-3.png'
            },
            {
              title:'济南地铁1号线',
              content:'济南地铁1号线 王府庄站进行了巡检设备轨道地板异物检测模块现场应用，帮助济南地铁对轨道地板上出现的异物进行检测，测试通过人为摆放异物的方式对装备检测效果进行检验。测试结果表明，装备能够有效识别到测试放置的异物，达到保障列车安全运行的效果。',
              img: '/static/case-1-4.png'
            },
            {
              title:'胶州湾海底隧道',
              content:'监测方案',
              img: '/static/case-1-5.png'
            },
            {
              title:'穿黄隧道',
              content:'穿黄隧道',
              img: '/static/case-1-6.png'
            },
          ]
        },
        {
          title: '道桥工程检测监测方案',
          children: [
            {
              title:'道路智能检测与数字化运维方案',
              content:'为全面提升道路养护的精准性和效率，本方案采用无人机巡航检测系统搭配自动巡检机器人检测设备相结合的方式，构建空-地一体化的智能检测体系，并依托大数据分析、三维重建及AI病害识别技术，实现道路全生命周期的数字化运维管理。',
              img: '/static/case-2-1.png'
            },
            {
              title:'桥梁检测方案',
              content:'为提升桥梁结构健康监测的效率和精度，本方案采用无人机智能巡检技术，结合人工智能（AI）图像识别与三维建模，实现对桥梁表观病害的高精度检测与自动化分析，大幅降低人工巡检的安全风险与成本，为桥梁养护决策提供科学依据。',
              img: '/static/case-2-2.png'
            }
          ]
        },
        {
          title: '矿山工程检测监测方案',
          children: [
            {
              title:'矿山工程检测监测方案',
              content:'本方案设计了一套集智能监测、实时预警与水源识别于一体的矿井水文地质监测预报预警平台。该系统依托物联网、大数据分析和人工智能技术，对地下水水位、水压、水质、视频监控、水仓流量等关键参数进行全天候动态监测，构建矿山全生命周期的智能化水文管理体系。',
              img: '/static/case-3-1.png'
            }
          ]
        },
      ],
      caseActive: 0
    }
  },

  mounted() {
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  }
}
</script>

<style scoped lang="scss">
.scheme-content{
  background: #131415;
}
.banner{
  height: 540px;
  background: url(../assets/images/case/banner.png) no-repeat center top;
  background-size: auto 100% ;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  .title{
    font-size: 52px;
  }
  .info{
    font-size: 16px;
    text-align: center;
    width: 100%;
    line-height: 32px;
    margin-top: 16px;
  }
}
.scheme-list{
  padding: 0 20px;
  .case-top{
    background: #242424;
    display: flex;
    margin: 0 -20px 20px;
    .case-item{
      flex: 1;
      line-height: 78px;
      text-align: center;
      font-size: 18px;
      color: #FFFFFF;
      cursor: pointer;
      &.active{
        background: #3D91FF;
      }
    }
  }
  .item{
    margin-bottom: 22px;
    background: #242832;
    border-radius: 4px;
    min-height: 480px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    padding: 30px 16px 16px; 
    .sub-title{
      font-size: 18px;
      line-height: 26px;
    }
    .title{
      font-size: 22px;
      line-height: 32px;
      margin-bottom: 12px;
    }
    .info{
      font-size: 14px;
      line-height: 24px;
      opacity: .6;
      text-align: left;
      min-height: 100px;
      height: 120px;
      margin-bottom: 24px;
      overflow: hidden;
      text-overflow: ellipsis; 
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
    }
    .link{
      font-size: 14px;
      color: #3D91FF;
      margin-bottom: 25px;
      text-align: left;
    }
    img{
      width: 100%;
      height: auto;
      transition: all .3s ease-in-out;
    }
  }
}

/* 平板设备适配 */
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .banner .title{
    font-size: 42px;
  }
  .scheme-list{
    .case-top .case-item{
      font-size: 16px;
      line-height: 60px;
    }
    .item{
      min-height: 400px;
      padding: 20px 16px;
      .title{
        font-size: 20px;
      }
    }
  }
}
/* 大屏幕PC适配 */
@media screen and (min-width: 1600px) {
  .scheme-list .item {
    min-height: 520px;
    padding: 40px 24px 24px;
    .title {
      font-size: 24px;
      line-height: 36px;
    }
    .info {
      font-size: 15px;
      line-height: 26px;
    }
  }
}

/* 中屏幕PC适配 (1481-1599px) */
@media screen and (max-width: 1599px) and (min-width: 1481px) {
  .scheme-list .item {
    min-height: 500px;
    padding: 35px 20px 20px;
  }
}

/* 小屏幕PC适配 (1200-1480px) */
@media screen and (max-width: 1480px) and (min-width: 1200px) {
  .banner-text .info{
    font-size: 18px;
    line-height: 28px;
  }
  .scheme-list .item {
      min-height: 480px;
    }
  }

@media screen and (max-width: 768px){
  .banner{
    height: 48vw;
    background: url(../assets/images/case/banner-mobile.png) no-repeat;
    background-size: 100% auto;
    padding-top: 30px;
    box-sizing: border-box;
    .title{
      font-size: 18px;
      line-height: 30px;
    }
    .info{
      font-size: 14px;
    }
  }
  .scheme-list{
    padding: 20px 16px;
    .item{
      min-height: 400px;
      .title{
        font-size: 24px;
      }
    }
    .info{
      min-height: auto!important;
      height: auto!important;
      font-size: 14px!important;
    }

  }
  .scheme-list .case-top{
    margin: 0 -16px 20px;
    .case-item{
      height: 60px;
      font-size: 14px!important;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 0 16px;

    }
  }
}
</style>
